export default "Escape Team åbnede i maj 2019. \n\nDe lukkede i marts 2021 og solgte deres rum til FunCenter.";